import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translate from 'react-translate-component';
import { keys, map, head } from 'ramda';
import { mapIndexed } from 'utils/ramdaAdditions';

import { getPersonItem } from 'helpers/personHelper';

export default class TablePerson extends Component {
    static propTypes = {
        items: PropTypes.array.isRequired,
        table: PropTypes.string.isRequired
    }

    renderHeader = (heads) => (
        <thead>
            <tr>
                { map((head) => (
                    <th key={head}><Translate content={`person.${head}`} /></th>
                ), heads)}
            </tr>
        </thead>
    );

    renderBody = (items) => (
        <tbody>
            { mapIndexed((item, rowIndex) => (
                <tr key={rowIndex}>
                    { mapIndexed((column, columnIndex) => (
                        <td key={columnIndex}>{ item[column] }</td>
                    ), keys(item))}
                </tr>
            ), items)}
        </tbody>
    );

    render () {
        const { items, table } = this.props;
        const rows = map(getPersonItem[table], items);
        const heads = keys(head(rows));

        return (
            <table className="card-table">
                { this.renderHeader(heads) }
                { this.renderBody(rows) }
            </table>
        );
    }
}
